import { HUD } from '@/config/hud';
import { t } from '@/i18n';
import type { ConfirmDialog } from './confirm-dialog';

/**
 * One-shot Xbox hint (split from game.ts): Edge ships the pad as a virtual
 * mouse until the player flips the address-bar "gamepad" control — if no
 * pad talks within the delay, SHOW the instructions ourselves (no click
 * needed to summon it).
 */
export class XboxHint {
  private done = !/Xbox/i.test(navigator.userAgent);
  private readonly at = performance.now() + HUD.xboxHintDelay;

  tick(titleOpen: boolean, confirm: ConfirmDialog, screenW: number, screenH: number): void {
    if (this.done) return;
    const padTalks = [...(navigator.getGamepads?.() ?? [])].some((p) => p?.connected);
    if (padTalks) this.done = true;
    else if (performance.now() > this.at && titleOpen) {
      this.done = true;
      confirm.show(screenW, screenH, t('xbox.gamepadHint'), () => {}, true);
    }
  }
}
